import { makeStyles } from '@material-ui/core/styles';
import useUser from '../../../auth/hooks';
import useApi from '../../../api';
import { useNavigator } from '../../../components/Navigator';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { t } from 'ttag';
import DialogContent from '@material-ui/core/DialogContent';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React from 'react';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    padding: '20px',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
  },
}));

export const FoundUserDialog = ({ athlete, open, onClose }) => {
  const { user: authUser } = useUser();
  const api = useApi();
  const navigate = useNavigator();
  const classes = useStyles();
  const canEdit = authUser.isAdmin || athlete.trainerIds.includes(authUser.id);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t`Такий користувач вже існує`}</DialogTitle>
      <DialogContent>
        <Card className={classes.root}>
          <CardMedia className={classes.cover} image={athlete.photo.url} />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography component='h6' variant='h6'>
                {athlete.fullName}
              </Typography>
              <Typography variant='subtitle1' color='textSecondary'>
                {athlete.birthday}
              </Typography>
            </CardContent>
          </div>
        </Card>
      </DialogContent>
      <DialogActions>
        {canEdit ? (
          <Button
            size='small'
            color='primary'
            variant='contained'
            onClick={() => navigate(api.router.athletes.edit(athlete.id))}
          >
            {t`Перейти до редагування`}
          </Button>
        ) : (
          <Typography component='h6' variant='h6'>
            {t`Зверніться будьласка до адміністратору сервісу щоб додати користувача`}
          </Typography>
        )}
        <Button
          size='small'
          color='primary'
          variant='outlined'
          onClick={() => {
            navigate(api.router.athletes.list());
          }}
        >
          {t`Перейти до списку`}
        </Button>
        <Button
          size='small'
          color='primary'
          variant='outlined'
          onClick={onClose}
        >
          {t`Продовжити`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
